export const SALE_ERROR_MESSAGES: Record<string, string> = {
  // Structure errors
  'SALE_BODY_REQUIRED': 'Données de la vente manquantes.',
  'SALE_POS_REQUIRED': 'Veuillez sélectionner une caisse.',

  // Requirement errors
  'SALE_REQUIREMENTS_REQUIRED': 'La vente doit contenir au moins un article.',
  'SALE_REQUIREMENT_INVALID': 'Un article de la vente est invalide.',
  'SALE_REQUIREMENT_QUANTITY_INVALID': 'La quantité d\'un article est invalide (doit être > 0).',
  'SALE_REQUIREMENT_PRICE_INVALID': 'Le prix unitaire d\'un article est invalide.',
  'SALE_REQUIREMENT_TAX_RATE_INVALID': 'Le taux de taxe d\'un article est invalide.',
  'SALE_REQUIREMENT_REBATE_INVALID': 'Le rabais d\'un article est invalide.',
  'SALE_TAX_INCLUDED_NOT_SUPPORTED': 'Le mode TTC n\'est pas supporté pour les ventes POS.',
  'SALE_REVERSE_CHARGE_NOT_SUPPORTED_FOR_POS': 'Les codes Reverse Charge ne sont pas supportés pour les ventes POS.',

  // Payment errors
  'SALE_PAYMENTS_REQUIRED': 'Veuillez ajouter au moins un paiement.',
  'SALE_PAYMENT_METHOD_REQUIRED': 'Mode de paiement manquant.',
  'SALE_PAYMENT_AMOUNT_INVALID': 'Montant de paiement invalide.',
  'SALE_PAYMENT_TREASURY_REQUIRED': 'Compte de trésorerie manquant.',
  'SALE_EXCHANGE_RATE_REQUIRED': 'Taux de change requis pour la devise étrangère.',
  'SALE_PAYMENT_ACCOUNTING_ENTRY_REQUIRED': 'Veuillez sélectionner une écriture comptable pour le paiement de type dépôt.',
  'SALE_PAYMENT_MISMATCH': 'Le total des paiements ne correspond pas au montant de la vente.',

  // Customer errors
  'SALE_CUSTOMER_REQUIRED': 'Aucun client par défaut sur cette caisse, veuillez en sélectionner un.',
  'SALE_CUSTOMER_INVALID_TYPE': 'Type de client invalide.',
  'SALE_CUSTOMER_FIELDS_REQUIRED': 'Informations client incomplètes.',

  // Amount mismatch (special: also logged to console in PosSaleCreate)
  'SALE_AMOUNT_MISMATCH': 'Erreur de calcul détectée. Veuillez recharger la page et réessayer. Si le problème persiste, contactez le support.',

  // POS
  'POS_NOT_FOUND': 'La caisse sélectionnée est introuvable.',
}
